import { service_translate_generations } from '@/services/translate/SERVICE__translate_generations';
import { service_translate_searches } from '@/services/translate/service_translate_searches';
import { service_translate_word_with_related_words } from '@/services/translate/service_translate_word_with_related_words';
import { store } from '@/state/store';
import { local_words_upsert } from '@/state/words/local_words_upsert';
import { local_words_with_related_words_upsert } from '@/state/words/local_words_with_related_words_upsert';
import { local_word_with_related_words_create_in_progress_delete } from '@/state/words/related_words_create/local_word_with_related_words_create_in_progress_delete';
import { local_word_with_related_words_get_in_progress_delete } from '@/state/words/related_words_get/local_word_with_related_words_get_in_progress_delete';
import { local_words_translating_in_progress_delete } from '@/state/words/translate_from_english/local_words_translating_in_progress_delete';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTOWordWithRelatedWords } from '@shared/dto/+word/word_with_related_words/dto_word_with_related_words';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../_methods/add_socket_handler_client';

export function add_socket_handlers_client_words() {
  add(ENE.WORDS_UPSERT, (items: DTO__word[]) => {
    store.dispatch(local_words_upsert(items));

    service_translate_generations.on_received_words(items);
    service_translate_searches.on_received_words(items);
    service_translate_word_with_related_words.on_received_words(items);

    store.dispatch(local_words_translating_in_progress_delete(items));
  });

  add(ENE.WORDS_WITH_RELATED_WORDS_UPSERT, (items: DTOWordWithRelatedWords[]) => {
    store.dispatch(local_word_with_related_words_get_in_progress_delete(items.map(item => item.word_english)));
    store.dispatch(local_word_with_related_words_create_in_progress_delete(items.map(item => item.word_english)));

    store.dispatch(local_words_with_related_words_upsert(items));
  });
}
